document.addEventListener('DOMContentLoaded', () => {
  const title = document.querySelector('.strength-en-title');
  const underline = document.querySelector('.strength-underline');

  if (!title || !underline) return;

  // 初期状態（非表示）
  title.style.transform = 'translateX(-100%)';
  title.style.opacity = '0';
  underline.style.width = '0';
  underline.style.opacity = '1';

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const rect = entry.boundingClientRect;
      const centerY = rect.top + rect.height / 2;
      const isCentered = Math.abs(centerY - window.innerHeight / 2) < 20;

      if (entry.isIntersecting && isCentered) {
        // スライドイン＋下線表示
        title.style.transition = 'transform 0.8s ease, opacity 0.8s ease';
        underline.style.transition = 'width 0.8s ease, opacity 0.8s ease';

        requestAnimationFrame(() => {
          title.style.transform = 'translateX(0)';
          title.style.opacity = '1';
          underline.style.width = `${title.offsetWidth}px`;
        });

        // 一定時間後に下線を消す
        setTimeout(() => {
          underline.style.width = '0';
          underline.style.opacity = '0';
        }, 1300);

        observer.unobserve(entry.target); // 一度きりの実行にする
      }
    });
  }, {
    threshold: 0.1
  });

  observer.observe(title);
});


